import PropTypes from 'prop-types';
import { useRouter } from 'next/router';

import Container from 'components/container';
import Layout from 'components/layout';
import Springboard from 'components/springboard';
import { getAllKeywords } from 'lib/api/keywords';
import { toPlainText } from 'utilities/blockText';
import { allCommandsByName } from 'utilities/commands';
import { KeywordType } from 'utilities/propTypes';

export const getStaticProps = async ({ preview = false }) => {
  const keywords = await getAllKeywords({ preview });
  return {
    props: {
      keywords,
      preview,
    },
  };
};

const Go = ({ keywords }) => {
  const router = useRouter();
  const keyword = router.query.keyword || 'resist'; // Use keyword from query params, otherwise default message.

  // If the command does not exist in CMS, try to get it from command map or use default message.
  const keywordMatch = keywords.find((k) => k.keyword === keyword);
  const entry = allCommandsByName.get(keyword);
  const entryDescription = entry
    ? entry.command.description
    : 'Introduce yourself!';

  const message = keywordMatch?.description
    ? toPlainText(keywordMatch.description)
    : entryDescription;

  return (
    <Layout title={`Go: ${keyword}`} description={message}>
      <Container>
        <Springboard keyword={keyword} message={message} />
      </Container>
    </Layout>
  );
};

Go.propTypes = {
  keywords: PropTypes.arrayOf(KeywordType),
  preview: PropTypes.bool,
};

export default Go;
